export type MdModule = {
  html: string;
  attributes: Record<string, string>;
};

/** Groups import.meta.glob results ('./en/deposit-crypto.md' → ...) into { 'deposit-crypto': { en: load } }. */
export const byLang = <T>(files: Record<string, T>) => {
  const docs: Record<string, Partial<Record<string, T>>> = {};
  for (const [path, load] of Object.entries(files)) {
    const [, lang, file] = path.split('/');
    const name = file.slice(0, -'.md'.length);
    docs[name] ??= {};
    docs[name][lang] = load;
  }
  return docs;
};
